import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a4641e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "-edit-main" }
const _hoisted_2 = { class: "pageWrap -psr" }
const _hoisted_3 = { class: "tree-psa" }
const _hoisted_4 = { class: "-w300" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tree" }, null, -1))
const _hoisted_6 = { class: "-w300" }
const _hoisted_7 = { class: "-edit-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取 消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_tree, {
          data: $setup.treeData,
          ref: "treeRef",
          "show-checkbox": "",
          "node-key": "id",
          "default-expand-all": "",
          "default-checked-keys": $setup.treeSelect
        }, null, 8, ["data", "default-checked-keys"])
      ])
    ]),
    _createVNode(_component_el_form, {
      class: "-form -full",
      model: $setup.form,
      rules: $setup.rules,
      ref: $setup.setting.formName,
      onSubmit: [
        _cache[4] || (_cache[4] = ($event: any) => ($options._formSubmit())),
        _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
      ]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "角色名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "权限设置",
          prop: "permissionId"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "角色描述",
          prop: "remark"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.remark,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.remark) = $event)),
              rows: 5,
              type: "textarea"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排列顺序",
          prop: "orderBy"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.orderBy,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.orderBy) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "primary",
            "native-type": "submit",
            title: "按下'Ctrl + Enter'键可快速提交"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            title: "按下'Esc'可快速关闭",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.closeDrawer()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}